export function normalizeAppRole(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toLowerCase().replace(/[\s-]+/g, '_');

  switch (normalized) {
    case 'credentials_partner':
    case 'credentials_partener':
    case 'credentialing_partener':
      return 'credentialing_partner';
    case 'billing_partener':
      return 'billing_partner';
    case 'rn':
    case 'registered_nurse':
    case 'nurse':
      return 'nurse';
    case 'lpn':
    case 'lvn':
    case 'licensed_practical_nurse':
    case 'licensed_vocational_nurse':
      return 'lpn';
    case 'cna':
    case 'certified_nursing_assistant':
      return 'cna';
    case 'hha':
    case 'home_health_aide':
      return 'hha';
    case 'caregiver':
    case 'personal_care_aide':
      return 'caregiver';
    case 'companion':
    case 'sitter':
      return 'companion';
    case 'scheduler':
      return 'scheduler';
    case 'employee':
      return 'employee';
    case 'contractor':
      return 'contractor';
    case 'provider':
    case 'md':
    case 'doctor':
    case 'physician':
      return 'provider';
    case 'np':
    case 'nurse_practitioner':
      return 'np';
    case 'org_admin':
      return 'org_admin';
    case 'clinical_admin':
      return 'clinical_admin';
    case 'superadmin':
    case 'super_admin':
      return 'super_admin';
    case 'social_worker':
      return 'social-worker';
    // Kept in step with functions/src/role-utils.ts -- see the note there.
    // The rules' front-desk role is 'employer'; 'frontdesk' matches nothing.
    // Wound-round leadership roles. They review rounds, details, QA and
    // reports, but the wound access policy keeps them out of evaluation
    // authoring and the editable wound module.
    case 'don':
    case 'director_of_nursing':
    case 'nursing_director':
      return 'don';
    case 'wound_nurse':
    case 'wound_care_nurse':
    case 'woundnurse':
      return 'wound_nurse';
    case 'frontdesk':
    case 'front_desk':
    case 'reception':
    case 'receptionist':
      return 'employer';
    default:
      return normalized;
  }
}

export function normalizeAppRoles(values: unknown[]): string[] {
  return Array.from(
    new Set(
      values
        .map((value) => normalizeAppRole(value))
        .filter((value): value is string => !!value)
    )
  );
}
